import rgbHex from 'rgb-hex';
import colorStringToObj from './colorStringToObj';

function colorStringToHexAndAlpha(str = ''): {
  hex: string;
  alpha: number;
} {
  const { r, g, b, a: alpha } = colorStringToObj(str);
  try {
    return { hex: `#${rgbHex(r, g, b)}`, alpha };
  } catch (e) {
    return { hex: '#000000', alpha };
  }
}

export default colorStringToHexAndAlpha;
